import { createSlice } from '@reduxjs/toolkit';
import extraReducers from './extra-reducers';
import reducers from './reducers';
import { chatInitialState } from './types';

const chatSlice = createSlice({
  name: 'chat',
  initialState: chatInitialState,
  reducers,
  extraReducers: (builder) => extraReducers(builder),
});

export const {
  addMessage,
  setMessages,
  clearMessages,
  setUploadingFiles,
  setError,
  setSelectedConversationId,
  setLiveUpdatesPaused,
  addIncomingMessage,
  addCreatedConversation,
  updateMessageStatus,
  deleteMessage,
  addTypingUser,
  removeTypingUser,
  clearTypingUsers,
  setCurrentConversation,
  clearCurrentConversation,
  prependOlderMessages,
  updateMessageDeliveryStatus,
  markConversationMessagesAsRead,
  updateConversationOverview,
  addNewConversation,
  addOptimisticMessage,
  replaceOptimisticMessage,
  markOptimisticMessageFailed,
  removeOptimisticMessage,
} = chatSlice.actions;

export default chatSlice.reducer;
